import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'is_the_fac_consulting_w_trade_unions_in_line_w_legal_reqs'

export const dataPointDefinition = {
  retracedId: 'is_the_fac_consulting_w_trade_unions_in_line_w_legal_reqs',
  name: 'Is the facility consulting with trade unions in line with legal requirements?',
  description:
    'For example, national law may require the employer to consult with unions regarding business decisions that have a collective impact, such as workforce restructurings or mass layoffs.\r\r\n\r\r\nUnion presence in the facility includes the existence of a company union and/or the affiliation of workers from the company to higher level unions (such as sectoral unions).\r\r\n\r\r\nConsult applicable legal requirements before answering this question. \r\r\n\r\r\nConsultation includes a genuine exchange of ideas and information that ensures that there is an opportunity for workers and their representatives to influence the decisions being made within the organization, particularly where any proposal may affect employment.\r\r\n\r\r\nIf there was no union presence in the facility during the assessment period, select the answer: Not applicable. No union presence in the facility during assessment period.\r\r\n\r\r\nReference: ILO Termination of Employment Convention (No. 158) and ILO Recommendation (No. 166), 1982.\r\r\n',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'union-na',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'union-na',
    },
    {
      name: 'Not applicable. No union presence in the facility during assessment period.',
      key: 'NOT_APPLICABLE_NO_UNION_PRESENCE_IN_THE_FAC_DURING_ASSESSMENT',
      slcpIndex: 3,
      slcpOptionName: 'union-na',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE_NO_UNION_PRESENCE_IN_THE_FAC_DURING_ASSESSMENT'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'foa-cb-3--7',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12150,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
